class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.applyUnifiedFilters();
		}, 300);

		const facetForm = this.querySelector("form");
		if (facetForm) {
			facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
		}
		this.addEventListener("click", this.onFacetFormClick.bind(this));
		this.addEventListener("change", this.onFacetFormChange.bind(this));

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

		const facetButton = this.querySelector(".facets__button-show");
		if (facetButton) {
			facetButton.onclick = (event) => {
				let labelHide = event.currentTarget.querySelector(".label-hide");
				let labelShow = event.currentTarget.querySelector(".label-show");

				labelHide.classList.toggle("hidden");
				labelShow.classList.toggle("hidden");

				let container = labelHide
					.closest("form")
					.querySelector(".facets__container");

				container.classList.toggle("active");
				document.body.classList.toggle(`overflow-hidden`);
				document.body.classList.toggle("filter-open");

				if (
					document.querySelector(
						".facets__container--horizontal:not(.active)"
					) != null
				) {
					let horizontalFilters = document.querySelector(
						".facets__container--horizontal:not(.active)"
					);
					horizontalFilters.classList.add("visible_container");

					setTimeout(
						() => horizontalFilters.classList.remove("visible_container"),
						600
					);
				}

				container.addEventListener("click", () => {
					if (container.querySelector(".facets__wrapper:hover") == null) {
						container.classList.remove("active");
						document.body.classList.remove(`overflow-hidden`);

						setTimeout(
							() => document.body.classList.remove(`filter-open`),
							700
						);
					}
				});
			};

			if (document.getElementById("SortBy") != null) {
				let select = document.getElementById("SortBy");
				select.addEventListener("click", () => select.classList.toggle("open"));
				select.addEventListener("blur", () => select.classList.remove("open"));
			}

			const facetCloseButton = this.querySelector(".facets-modal__close");
			facetCloseButton.addEventListener("click", () => {
				let container = facetCloseButton.closest(".facets__container");
				container.classList.remove("active");
				document.body.classList.remove(`overflow-hidden`);
				setTimeout(() => document.body.classList.remove(`filter-open`), 700);
			});

			const collectionGridSection =
				document.querySelector(".collection-grid-section") ||
				document.querySelector(".section-search");
			let prevWidth = 0;
			const sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
			});
			sectionResizeObserver.observe(collectionGridSection);
		}

		const checkboxes = document.querySelectorAll(
			'#FacetFiltersFormMobile .js-filter input[type="checkbox"]'
		);
		const removebtn = document.querySelector(
			"#FacetFiltersFormMobile .facets-tag-wrapper"
		);
		const allChecked = Array.from(checkboxes).some(
			(checkbox) => checkbox.checked
		);

		if (allChecked) {
			removebtn?.classList.remove("active");
		} else {
			removebtn?.classList.add("active");
		}

		this.initFromUrl();
		this.prefetchRemainingPages();
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const form = document.querySelector("facet-filters-form");
			if (form && typeof form.initFromUrl === "function") {
				form.initFromUrl();
			} else {
				const searchParams = event.state
					? event.state.searchParams
					: FacetFiltersForm.searchParamsInitial;
				const targetPath = event.state && event.state.targetPath
					? event.state.targetPath
					: window.location.pathname;
				if (
					searchParams === FacetFiltersForm.searchParamsPrev &&
					targetPath === FacetFiltersForm.targetPathPrev
				)
					return;
				FacetFiltersForm.renderPage(searchParams, null, false, targetPath);
			}
		};
		window.addEventListener("popstate", onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll(".js-facet-remove").forEach((element) => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true, targetPath = null) {
		const path = targetPath || window.location.pathname;
		FacetFiltersForm.searchParamsPrev = searchParams;
		FacetFiltersForm.targetPathPrev = path;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById(
			"ProductCountDesktop"
		);
		const gridContainer = document.getElementById("ProductGridContainer");
		if (gridContainer && gridContainer.querySelector(".collection")) {
			gridContainer.querySelector(".collection").classList.add("loading");
		}
		if (countContainer) {
			countContainer.classList.add("loading");
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add("loading");
		}

		sections.forEach((section) => {
			const url = `${path}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, path);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url },
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);

				if (window.initProductCardSlider) {
					window.initProductCardSlider();
				}
			})
			.catch((e) => {
				console.error("Facets render error:", e);
			})
			.finally(() => {
				document.querySelectorAll(".collection-product.loading, .collection.loading, #ProductGridContainer .loading, .loading").forEach((el) => {
					el.classList.remove("loading");
				});
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
		document.querySelectorAll(".collection-product.loading, .collection.loading, #ProductGridContainer .loading, .loading").forEach((el) => {
			el.classList.remove("loading");
		});
	}

	static renderProductGridContainer(html) {
		const parsedDoc = new DOMParser().parseFromString(html, "text/html");
		const newGrid = parsedDoc.getElementById("ProductGridContainer");
		const currentGrid = document.getElementById("ProductGridContainer");
		if (currentGrid && newGrid) {
			currentGrid.innerHTML = newGrid.innerHTML;
		}

		document.querySelectorAll(".collection-product.loading, .collection.loading, #ProductGridContainer .loading").forEach((el) => {
			el.classList.remove("loading");
		});

		if (
			document.querySelector(".js-load-more") ||
			document.querySelector(".js-infinite-scroll")
		)
			loadMore();

		colorSwatches();
	}

	static renderProductCount(html) {
		const parsedDoc = new DOMParser().parseFromString(html, "text/html");
		const countEl = parsedDoc.getElementById("ProductCount");
		const count = countEl ? countEl.innerHTML : "(0)";
		const container = document.getElementById("ProductCount");
		const containerDesktop = document.getElementById("ProductCountDesktop");
		if (container) {
			container.innerHTML = count;
			container.classList.remove("loading");
		}
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove("loading");
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");

		const facetDetailsElements = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest(".js-filter") : undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element)
		);
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			const targetEl = document.querySelector(
				`.js-filter[data-index="${element.dataset.index}"]`
			);
			if (targetEl) {
				targetEl.innerHTML = element.innerHTML;
			}
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender)
			FacetFiltersForm.renderCounts(
				countsToRender,
				event.target.closest(".js-filter")
			);

		const checkboxes = document.querySelectorAll(
			'#FacetFiltersFormMobile .js-filter input[type="checkbox"]'
		);
		const removebtn = document.querySelector(
			"#FacetFiltersFormMobile .facets-tag-wrapper"
		);
		const allChecked = Array.from(checkboxes).some(
			(checkbox) => checkbox.checked
		);

		if (allChecked) {
			removebtn?.classList.remove("active");
		} else {
			removebtn?.classList.add("active");
		}
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop",
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting",
		];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML =
				html.querySelector(selector).innerHTML;
		});
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector(".facets__selected");
		const sourceElement = source.querySelector(".facets__selected");

		const targetElementAccessibility = target.querySelector(".facets__summary");
		const sourceElementAccessibility = source.querySelector(".facets__summary");

		if (sourceElement && targetElement) {
			target.querySelector(".facets__selected").outerHTML =
				source.querySelector(".facets__selected").outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector(".facets__summary").outerHTML =
				source.querySelector(".facets__summary").outerHTML;
		}
	}

	static updateURLHash(searchParams, targetPath = null) {
		const path = targetPath || window.location.pathname;
		const query = searchParams ? `?${searchParams}` : "";
		history.pushState(
			{ searchParams, targetPath: path },
			"",
			`${path}${query}`
		);
	}

	static getSections() {
		return [
			{
				section: document.getElementById("product-grid").dataset.id,
			},
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	getCurrentCollectionHandle() {
		const activeTheme = document.querySelector(".facets__theme-link--active");
		if (activeTheme && activeTheme.dataset.themeHandle) {
			return activeTheme.dataset.themeHandle;
		}
		const parts = window.location.pathname.split("/").filter(Boolean);
		if (parts[0] === "collections" && parts[1] && parts[1] !== "all") {
			return parts[1];
		}
		return "all";
	}

	getCleanSearchParams() {
		const forms = [];
		const sortFilterForms = document.querySelectorAll("facet-filters-form form");
		sortFilterForms.forEach((form) => {
			if (
				form.id === "FacetSortForm" ||
				form.id === "FacetFiltersForm" ||
				form.id === "FacetFiltersFormMobile" ||
				form.id === "FacetSortDrawerForm"
			) {
				const formData = new FormData(form);
				const params = new URLSearchParams(formData);
				params.delete("blend_tag");
				params.delete("filter.p.tag");
				const str = params.toString();
				if (str) forms.push(str);
			}
		});
		return forms.join("&");
	}

	prefetchRemainingPages() {
		if (window._hasPrefetchedNextPage) return;
		window._hasPrefetchedNextPage = true;

		const nextLink = document.querySelector(".pagination__item--next, a[href*='page=2'], [data-next-url]");
		let nextUrl = nextLink ? (nextLink.getAttribute("href") || nextLink.dataset.nextUrl || nextLink.value) : null;
		if (!nextUrl && window.location.pathname.includes("/collections/all")) {
			nextUrl = "/collections/all?page=2";
		}
		if (!nextUrl) return;

		fetch(nextUrl)
			.then((res) => res.text())
			.then((html) => {
				const doc = new DOMParser().parseFromString(html, "text/html");
				const newCards = doc.querySelectorAll("#ProductGridContainer .collection-product-card");
				const grid = document.querySelector("#product-grid");
				if (grid && newCards.length > 0) {
					const hasActive = document.querySelectorAll(
						".js-theme-checkbox:checked, .js-blend-checkbox:checked, .js-color-checkbox:checked, input[name='filter.v.option.color']:checked"
					).length > 0;

					newCards.forEach((card) => {
						card.classList.add("js-prefetched-card");
						if (!hasActive) {
							card.style.display = "none";
						}
						grid.appendChild(card);
					});

					if (typeof colorSwatches === "function") {
						colorSwatches();
					}

					if (hasActive) {
						this.applyUnifiedFilters();
					}
				}
			})
			.catch((err) => console.debug("Prefetch notice:", err));
	}

	initFromUrl() {
		const params = new URLSearchParams(window.location.search);
		const themes = (params.get("collections") || params.get("themes") || "").split(",").map(t => t.trim().toLowerCase()).filter(Boolean);
		const blends = (params.get("blends") || "").split(",").map(b => b.trim().toLowerCase()).filter(Boolean);
		const colors = (params.get("colors") || "").split(",").map(c => c.trim().toLowerCase()).filter(c => c && c !== "sample" && c !== "fabric-sample");
		const minPrice = params.get("min_price");
		const maxPrice = params.get("max_price");

		const pathParts = window.location.pathname.split("/").filter(Boolean);
		if (pathParts[0] === "collections" && pathParts[1] && pathParts[1] !== "all") {
			const currentThemeHandle = pathParts[1].toLowerCase();
			if (!themes.includes(currentThemeHandle)) {
				themes.push(currentThemeHandle);
			}
		}

		let hasParam = false;
		themes.forEach(t => {
			const cb = document.querySelector(`.js-theme-checkbox[value="${t}"]`);
			if (cb) { cb.checked = true; hasParam = true; }
		});
		blends.forEach(b => {
			const cb = document.querySelector(`.js-blend-checkbox[value="${b}"], .js-blend-checkbox[data-blend-tag="${b}"]`);
			if (cb) { cb.checked = true; hasParam = true; }
		});
		colors.forEach(c => {
			const cb = document.querySelector(`.js-color-checkbox[value="${c}" i], .js-color-checkbox[data-color-value="${c}" i], input[name="filter.v.option.color"][value="${c}" i]`);
			if (cb) { cb.checked = true; hasParam = true; }
		});
		if (minPrice) {
			const minInput = document.querySelector("#Filter-Price-GTE, #Filter-Price-Min");
			if (minInput) { minInput.value = minPrice; hasParam = true; }
		}
		if (maxPrice) {
			const maxInput = document.querySelector("#Filter-Price-LTE, #Filter-Price-Max");
			if (maxInput) { maxInput.value = maxPrice; hasParam = true; }
		}

		if (hasParam) {
			this.applyUnifiedFilters();
		} else {
			const gridContainer = document.getElementById("ProductGridContainer");
			if (gridContainer) {
				gridContainer.classList.remove("is-filtering");
				gridContainer.classList.add("is-filtering-ready");
			}
		}
	}

	applyUnifiedFilters() {
		// 1. Gather selected themes
		const selectedThemes = Array.from(
			document.querySelectorAll(".js-theme-checkbox:checked")
		).map(cb => (cb.value || cb.dataset.themeHandle || "").trim().toLowerCase()).filter(Boolean);

		// 2. Gather selected blends
		const selectedBlends = Array.from(
			document.querySelectorAll(".js-blend-checkbox:checked")
		).map(cb => (cb.dataset.blendTag || cb.value || "").trim().toLowerCase()).filter(Boolean);

		// 3. Gather selected colors
		const selectedColors = Array.from(
			document.querySelectorAll('.facets__list--color input[type="checkbox"]:checked, .js-color-checkbox:checked, input[name="filter.v.option.color"]:checked')
		).map(cb => (cb.dataset.colorValue || cb.value || "").trim().toLowerCase()).filter(c => c && c !== "sample" && c !== "fabric-sample");

		// 4. Gather price range
		const minInput = document.querySelector("#Filter-Price-GTE, #Filter-Price-Min");
		const maxInput = document.querySelector("#Filter-Price-LTE, #Filter-Price-Max");
		const minPrice = minInput && minInput.value !== "" ? parseFloat(minInput.value) : 0;
		const maxPrice = maxInput && maxInput.value !== "" ? parseFloat(maxInput.value) : Infinity;

		// 5. Product card filtering
		const productCards = document.querySelectorAll("#ProductGridContainer .collection-product-card");
		const promoCards = document.querySelectorAll("#ProductGridContainer .collection-product-promo-img");
		const PER_PAGE = 32;
		const urlParams = new URLSearchParams(window.location.search);
		let currentPage = parseInt(urlParams.get("page")) || 1;

		const hasActiveFilter = selectedThemes.length > 0 || selectedBlends.length > 0 || selectedColors.length > 0 || minPrice > 0 || (maxPrice < Infinity && maxPrice > 0 && maxInput && maxInput.value !== maxInput.getAttribute("placeholder"));

		promoCards.forEach(promo => {
			promo.style.display = hasActiveFilter ? "none" : "";
		});

		const staticPaginations = document.querySelectorAll(".pagination-wrapper:not(#DynamicPaginationWrapper), .load-more-wrapper, .infinite-scroll-wrapper");

		const matchingCards = [];

		productCards.forEach(card => {
			const isPrefetched = card.classList.contains("js-prefetched-card");
			if (!hasActiveFilter && isPrefetched) {
				card.style.display = "none";
				return;
			}

			const prodThemes = (card.dataset.themes || "").toLowerCase().split(/\s+/).filter(Boolean);
			const prodColors = (card.dataset.colors || "").toLowerCase().split(",").map(c => c.trim()).filter(Boolean);
			const prodBlends = (card.dataset.blends || "").toLowerCase().split(/\s+/).filter(Boolean);
			const prodPrice = parseFloat(card.dataset.price || "0");

			// OR logic within Themes: matches if no themes selected OR product belongs to ANY selected theme
			const matchTheme = selectedThemes.length === 0 || selectedThemes.some(t => prodThemes.includes(t));

			// OR logic within Blends: matches if no blends selected OR product matches ANY selected blend
			const matchBlend = selectedBlends.length === 0 || selectedBlends.some(b => prodBlends.includes(b));

			// OR logic within Colors: matches if no colors selected OR product matches ANY selected color
			const matchColor = selectedColors.length === 0 || selectedColors.some(c => prodColors.includes(c));

			// Price Match
			const matchPrice = isNaN(prodPrice) || prodPrice === 0 || (prodPrice >= minPrice && prodPrice <= maxPrice);

			const isMatch = matchTheme && matchBlend && matchColor && matchPrice;

			if (isMatch) {
				matchingCards.push(card);
			} else {
				card.style.display = "none";
			}
		});

		let visibleCount = 0;

		if (!hasActiveFilter) {
			// No active filters: Restore default server pagination and show native current page cards
			staticPaginations.forEach(p => p.style.display = "");
			const dynamicPagWrapper = document.getElementById("DynamicPaginationWrapper");
			if (dynamicPagWrapper) {
				dynamicPagWrapper.style.display = "none";
				dynamicPagWrapper.innerHTML = "";
			}
			productCards.forEach(card => {
				if (!card.classList.contains("js-prefetched-card")) {
					card.style.display = "";
					visibleCount++;
				} else {
					card.style.display = "none";
				}
			});
		} else {
			// Active filters: Hide static pagination and enforce 32-items-per-page dynamic slicing
			staticPaginations.forEach(p => p.style.display = "none");
			visibleCount = matchingCards.length;

			const totalPages = Math.ceil(matchingCards.length / PER_PAGE);
			if (currentPage > totalPages && totalPages > 0) {
				currentPage = 1;
			}

			const startIndex = (currentPage - 1) * PER_PAGE;
			const endIndex = startIndex + PER_PAGE;

			matchingCards.forEach((card, index) => {
				card.style.display = (index >= startIndex && index < endIndex) ? "" : "none";
			});

			this.renderDynamicPagination(currentPage, totalPages);
		}

		// 6. Update counts
		const countEls = [document.getElementById("ProductCount"), document.getElementById("ProductCountDesktop")];
		countEls.forEach(el => {
			if (el) el.textContent = `(${visibleCount})`;
		});

		// 7. Toggle empty state
		const emptyEl = document.getElementById("ProductGridEmpty");
		if (emptyEl) {
			emptyEl.style.display = visibleCount === 0 ? "" : "none";
		}

		// 8. Update "Clear all" button state
		const clearContainers = document.querySelectorAll(".facets-remove__all .facet-remove");
		clearContainers.forEach(container => {
			if (hasActiveFilter) {
				container.classList.add("active");
				container.classList.remove("facet-remove--disabled");
			} else {
				container.classList.remove("active");
				container.classList.add("facet-remove--disabled");
			}
		});

		// 9. Update theme label active underlines
		document.querySelectorAll(".js-theme-checkbox").forEach(cb => {
			const label = cb.closest(".facets__item")?.querySelector(".facets__theme-label");
			if (label) {
				label.classList.toggle("facets__theme-link--active", cb.checked);
			}
		});

		// 10. Sync URL parameters
		this.syncFilterUrlParams(selectedThemes, selectedBlends, selectedColors, minPrice, maxPrice, maxInput, hasActiveFilter ? currentPage : 1);

		// 11. Reveal grid (remove anti-FOUC shield)
		const gridContainer = document.getElementById("ProductGridContainer");
		if (gridContainer) {
			gridContainer.classList.remove("is-filtering");
			gridContainer.classList.add("is-filtering-ready");
		}
	}

	renderDynamicPagination(currentPage, totalPages) {
		const dynamicPagWrapper = document.getElementById("DynamicPaginationWrapper");
		if (!dynamicPagWrapper) return;

		if (totalPages <= 1) {
			dynamicPagWrapper.style.display = "none";
			dynamicPagWrapper.innerHTML = "";
			return;
		}

		dynamicPagWrapper.style.display = "";
		let pagesHtml = "";

		if (currentPage > 1) {
			pagesHtml += `
				<li>
					<a href="#" class="pagination__item--prev pagination__item-arrow link motion-reduce js-dynamic-page-link" data-page="${currentPage - 1}" aria-label="Previous page">
						<svg class="icon icon-caret-left" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M7 11L2 6L7 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</a>
				</li>
			`;
		}

		for (let i = 1; i <= totalPages; i++) {
			if (i === currentPage) {
				pagesHtml += `
					<li>
						<span class="pagination__item pagination__item--current" aria-current="page">${i}</span>
					</li>
				`;
			} else {
				pagesHtml += `
					<li>
						<a href="#" class="pagination__item link js-dynamic-page-link" data-page="${i}">
							<span>${i}</span>
						</a>
					</li>
				`;
			}
		}

		if (currentPage < totalPages) {
			pagesHtml += `
				<li>
					<a href="#" class="pagination__item--next pagination__item-arrow link motion-reduce js-dynamic-page-link" data-page="${currentPage + 1}" aria-label="Next page">
						<svg class="icon icon-caret-right" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 11L6 6L1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</a>
				</li>
			`;
		}

		dynamicPagWrapper.innerHTML = `
			<nav class="pagination" role="navigation" aria-label="Pagination">
				<ul class="pagination__list list-unstyled" role="list">
					${pagesHtml}
				</ul>
			</nav>
		`;

		dynamicPagWrapper.querySelectorAll(".js-dynamic-page-link").forEach((link) => {
			link.addEventListener("click", (e) => {
				e.preventDefault();
				const targetPage = parseInt(link.dataset.page);
				if (!isNaN(targetPage)) {
					const params = new URLSearchParams(window.location.search);
					if (targetPage > 1) {
						params.set("page", targetPage);
					} else {
						params.delete("page");
					}
					const newUrl = `${window.location.pathname}${params.toString() ? "?" + params.toString() : ""}`;
					window.history.replaceState({ path: newUrl }, "", newUrl);
					this.applyUnifiedFilters();
					document.getElementById("ProductGridContainer")?.scrollIntoView({ behavior: "smooth" });
				}
			});
		});
	}

	syncFilterUrlParams(themes, blends, colors, minPrice, maxPrice, maxInput, currentPage = 1) {
		const params = new URLSearchParams();
		if (themes.length > 0) params.set("themes", themes.join(","));
		if (blends.length > 0) params.set("blends", blends.join(","));
		if (colors.length > 0) params.set("colors", colors.join(","));
		if (minPrice > 0) params.set("min_price", minPrice);
		if (maxPrice < Infinity && maxPrice > 0 && maxInput && maxInput.value !== maxInput.getAttribute("placeholder")) {
			params.set("max_price", maxPrice);
		}
		if (currentPage > 1) {
			params.set("page", currentPage);
		}
		const queryString = params.toString();
		let currentPath = window.location.pathname;
		if (themes.length > 1 || (themes.length === 1 && currentPath !== `/collections/${themes[0]}`)) {
			currentPath = "/collections/all";
		} else if (themes.length === 0 && currentPath !== "/collections/all" && (blends.length > 0 || colors.length > 0)) {
			currentPath = "/collections/all";
		}
		const newUrl = `${currentPath}${queryString ? "?" + queryString : ""}`;
		window.history.replaceState({ path: newUrl }, "", newUrl);
	}

	onFacetFormClick(event) {
		const themeReset = event.target.closest(".js-theme-reset");
		if (themeReset) {
			event.preventDefault();
			event.stopPropagation();
			this.onThemeResetClick();
			return;
		}

		const blendReset = event.target.closest(".js-blend-reset");
		if (blendReset) {
			event.preventDefault();
			event.stopPropagation();
			this.onBlendResetClick();
			return;
		}

		const colorReset = event.target.closest(".js-color-reset");
		if (colorReset) {
			event.preventDefault();
			event.stopPropagation();
			this.onColorResetClick();
			return;
		}

		const clearAll =
			event.target.closest(".active-facets__button-remove") ||
			event.target.closest(".facets-remove__all a") ||
			event.target.closest(".js-clear-filters-link") ||
			event.target.closest("#ProductGridEmpty a");
		if (clearAll) {
			event.preventDefault();
			event.stopPropagation();
			this.onClearAllClick();
			return;
		}
	}

	onFacetFormChange(event) {
		const params = new URLSearchParams(window.location.search);
		if (params.has("page")) {
			params.delete("page");
			const newUrl = `${window.location.pathname}${params.toString() ? "?" + params.toString() : ""}`;
			window.history.replaceState({ path: newUrl }, "", newUrl);
		}
		this.applyUnifiedFilters();
	}

	onThemeResetClick() {
		document.querySelectorAll(".js-theme-checkbox").forEach(cb => {
			cb.checked = false;
		});
		const params = new URLSearchParams(window.location.search);
		if (params.has("page")) {
			params.delete("page");
			const newUrl = `${window.location.pathname}${params.toString() ? "?" + params.toString() : ""}`;
			window.history.replaceState({ path: newUrl }, "", newUrl);
		}
		this.applyUnifiedFilters();
	}

	onBlendResetClick() {
		document.querySelectorAll(".js-blend-checkbox").forEach(cb => {
			cb.checked = false;
		});
		const params = new URLSearchParams(window.location.search);
		if (params.has("page")) {
			params.delete("page");
			const newUrl = `${window.location.pathname}${params.toString() ? "?" + params.toString() : ""}`;
			window.history.replaceState({ path: newUrl }, "", newUrl);
		}
		this.applyUnifiedFilters();
	}

	onColorResetClick() {
		document.querySelectorAll('.facets__list--color input[type="checkbox"], .js-color-checkbox, input[name="filter.v.option.color"]').forEach(cb => {
			cb.checked = false;
		});
		const params = new URLSearchParams(window.location.search);
		if (params.has("page")) {
			params.delete("page");
			const newUrl = `${window.location.pathname}${params.toString() ? "?" + params.toString() : ""}`;
			window.history.replaceState({ path: newUrl }, "", newUrl);
		}
		this.applyUnifiedFilters();
	}

	onClearAllClick() {
		document.querySelectorAll(".js-theme-checkbox, .js-blend-checkbox, .js-color-checkbox, input[name='filter.v.option.color']").forEach(cb => {
			cb.checked = false;
		});
		const minInput = document.querySelector("#Filter-Price-GTE, #Filter-Price-Min");
		const maxInput = document.querySelector("#Filter-Price-LTE, #Filter-Price-Max");
		if (minInput && minInput.getAttribute("min")) minInput.value = minInput.getAttribute("min");
		if (maxInput && maxInput.getAttribute("max")) maxInput.value = maxInput.getAttribute("max");

		window.history.replaceState({ path: "/collections/all" }, "", "/collections/all");

		this.applyUnifiedFilters();
	}

	onSubmitHandler(event) {
		event.preventDefault();
		this.applyUnifiedFilters();
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const href =
			event.currentTarget.getAttribute("href") ||
			event.currentTarget.href ||
			"";

		const isClearAll =
			event.currentTarget.classList.contains("active-facets__button-remove") ||
			event.currentTarget.closest(".facets-remove__all") !== null ||
			(href.startsWith("/collections/all") && !href.includes("?"));

		if (isClearAll) {
			this.onClearAllClick();
			return;
		}

		let targetPath = window.location.pathname;
		let searchParams = "";
		try {
			const parsed = new URL(href, window.location.origin);
			targetPath = parsed.pathname;
			searchParams = parsed.search.slice(1);
		} catch (e) {
			searchParams =
				href.indexOf("?") === -1 ? "" : href.slice(href.indexOf("?") + 1);
		}

		FacetFiltersForm.renderPage(searchParams, null, true, targetPath);

		const removebtn = document.querySelector(
			"#FacetFiltersFormMobile .facets-tag-wrapper"
		);
		removebtn?.classList.add("active");
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.targetPathPrev = window.location.pathname;
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll("input").forEach((element) =>
			element.addEventListener("change", this.onRangeChange.bind(this))
		);
		this.setMinAndMaxValues();
		this.controlSlider();
		this.controlInput();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
		const form = document.querySelector("facet-filters-form");
		if (form && typeof form.applyUnifiedFilters === "function") {
			form.applyUnifiedFilters();
		}
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll("input");
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute("max", maxInput.value);
		if (minInput.value) maxInput.setAttribute("min", minInput.value);
		if (minInput.value === "") maxInput.setAttribute("min", 0);
		if (maxInput.value === "")
			minInput.setAttribute("max", maxInput.getAttribute("max"));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute("min"));
		const max = Number(input.getAttribute("max"));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}

	fillSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		inputRangeWrappers.forEach((inputWrapper) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];

			const range = inputRangeTo.max - inputRangeTo.min;
			const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
			const toCurrent = inputRangeTo.value - inputRangeTo.min;
			const minRange = (fromCurrent / range) * 100;
			const maxRange = (toCurrent / range) * 100;

			inputWrapper.setAttribute(
				"style",
				`--range-min: ${minRange}%; --range-max: ${maxRange}%`
			);
		});
	}

	controlSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputRangeWrappers.forEach((inputWrapper, index) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];
			const inputNumberFrom =
				inputNumberWrappers[index].querySelectorAll(".field__input")[0];
			const inputNumberTo =
				inputNumberWrappers[index].querySelectorAll(".field__input")[1];

			inputRangeFrom.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);
				if (from > to) {
					inputRangeFrom.value = to;
					inputNumberFrom.value = to;
				} else {
					inputNumberFrom.value = from;
				}

				this.fillSlider();
			};

			if (Number(inputRangeTo.value) <= 0) {
				inputRangeTo.style.zIndex = 2;
			} else {
				inputRangeTo.style.zIndex = 0;
			}

			inputRangeTo.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);
				if (from <= to) {
					inputRangeTo.value = to;
					inputNumberTo.value = to;
				} else {
					inputNumberTo.value = from;
					inputRangeTo.value = from;
				}

				if (Number(inputRangeTo.value) <= 0) {
					inputRangeTo.style.zIndex = 2;
				} else {
					inputRangeTo.style.zIndex = 0;
				}

				this.fillSlider();
			};
		});
	}

	controlInput() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputNumberWrappers.forEach((inputWrapper, index) => {
			const inputsNumber = inputWrapper.querySelectorAll(".field__input");
			const inputNumberFrom = inputsNumber[0];
			const inputNumberTo = inputsNumber[1];
			const inputRangeFrom =
				inputRangeWrappers[index].querySelectorAll(".field__range")[0];
			const inputRangeTo =
				inputRangeWrappers[index].querySelectorAll(".field__range")[1];

			inputNumberFrom.oninput = () => {
				const from = parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);
				if (from > to) {
					inputRangeFrom.value = to;
					inputNumberFrom.value = to;
				} else {
					inputRangeFrom.value = from;
				}

				this.fillSlider();
			};

			inputNumberTo.oninput = () => {
				const from = parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);
				if (from <= to) {
					inputRangeTo.value = to;
					inputNumberTo.value = to;
				} else {
					inputNumberTo.value = from;
				}

				this.fillSlider();
			};
		});
	}
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		const facetLink = this.querySelector("a");
		if (facetLink && !this._hasBound) {
			this._hasBound = true;
			facetLink.setAttribute("role", "button");
			facetLink.addEventListener("click", this.closeFilter.bind(this));
			facetLink.addEventListener("keyup", (event) => {
				event.preventDefault();
				if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
			});
		}
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest("facet-filters-form") ||
			document.querySelector("facet-filters-form");
		if (form && typeof form.onActiveFilterClick === "function") {
			form.onActiveFilterClick(event);
		}
	}
}

customElements.define("facet-remove", FacetRemove);
class VariantWeightRange extends HTMLElement {
	constructor() {
		super();
		this.minInput = this.querySelector('#Filter-Weight-Min-Pseudo');
		this.maxInput = this.querySelector('#Filter-Weight-Max-Pseudo');
		this.minNumInput = this.querySelector('#Filter-Weight-GTE-Pseudo');
		this.maxNumInput = this.querySelector('#Filter-Weight-LTE-Pseudo');
		this.checkboxes = this.querySelectorAll('.js-weight-hidden-check');
		this.rangeContainer = this.querySelector('.facets__range');

		if (this.minInput) {
			this.minInput.addEventListener('input', this.updateRange.bind(this));
			this.minInput.addEventListener('change', this.applyWeightFilter.bind(this));
		}
		if (this.maxInput) {
			this.maxInput.addEventListener('input', this.updateRange.bind(this));
			this.maxInput.addEventListener('change', this.applyWeightFilter.bind(this));
		}
		if (this.minNumInput) {
			this.minNumInput.addEventListener('change', (e) => {
				this.minInput.value = e.target.value;
				this.updateRange();
				this.applyWeightFilter();
			});
		}
		if (this.maxNumInput) {
			this.maxNumInput.addEventListener('change', (e) => {
				this.maxInput.value = e.target.value;
				this.updateRange();
				this.applyWeightFilter();
			});
		}

		this.updateRange();
	}

	updateRange() {
		const min = parseInt(this.minInput.value);
		const max = parseInt(this.maxInput.value);
		const totalMax = parseInt(this.minInput.max);

		if (this.rangeContainer) {
			this.rangeContainer.style.setProperty('--range-min', (min / totalMax * 100) + '%');
			this.rangeContainer.style.setProperty('--range-max', (max / totalMax * 100) + '%');
		}

		this.minNumInput.value = min;
		this.maxNumInput.value = max;
	}

	applyWeightFilter() {
		const min = parseInt(this.minInput.value);
		const max = parseInt(this.maxInput.value);

		this.checkboxes.forEach(cb => {
			const weight = parseInt(cb.dataset.weight);
			cb.checked = (weight >= min && weight <= max);
		});

		const form = this.closest('form');
		if (form) {
			form.dispatchEvent(new Event('input', { bubbles: true }));
		}
	}
}

customElements.define("variant-weight-range", VariantWeightRange);

document.addEventListener("click", (e) => {
	const clearLink = e.target.closest(".js-clear-filters-link, #ProductGridEmpty a");
	if (clearLink) {
		e.preventDefault();
		const form = document.querySelector("facet-filters-form");
		if (form && typeof form.onClearAllClick === "function") {
			form.onClearAllClick();
		}
	}
});
